module.exports = __webpack_public_path__ + "static/media/navigation.28365406.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Main/assets/navigation.png
// module id = 553
// module chunks = 0